export const GET_POPULAR_MOVIES = 'GET_POPULAR_MOVIES';
export const GET_SIMILAR_MOVIES = 'GET_SIMILAR_MOVIES';